import React from "react"
import {Wrapper} from "./styled"

const Letter = ({letter, positionX, positionY}) => (
  <Wrapper
    draggable={true}
    positionX={positionX}
    positionY={positionY}
  >
    {letter}
  </Wrapper>
)

export default Letter